import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TasksArchivedComponent } from './tasks-archived.component';
import { MatMenuModule } from '@angular/material/menu';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';

@NgModule({
    declarations: [TasksArchivedComponent],
    imports: [
        CommonModule,
        MatMenuModule,
        FiAppTextSharedModule,
        MatIconModule,
        FiWrapperTableModule,
        MatSortModule,
        FiFormatDateModule,
        MatButtonModule,
        MatTableModule,
        FiRollupContentModule,
        FiItemsListModule,
    ],
    exports: [TasksArchivedComponent],
})
export class TasksArchivedModule {}
